import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useTranslation } from 'react-i18next';

const ConfirmDialog = ({ open, onClose, isLoading, onConfirm }) => {

    const { t } = useTranslation();
        
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>{t('delete_staff_hours_title')}</DialogTitle>
            <DialogContent>
                <Typography>{t('delete_staff_hours_description')}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('cancel')}</Button>
                <LoadingButton
                    onClick={onConfirm}
                    loading={isLoading} 
                    variant="contained"
                    color='error'
                    >
                    {t('delete')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
